import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';

import {logger} from './logger';
import StoreProvider from './provider';
import {createStoreFrom} from './store';

export function render(children, initState = {}, props, rootNode) {
  const _props = {logger, ...props};
  const middlewares = [thunk.withExtraArgument(_props)];
  const store = createStoreFrom(initState, middlewares);

  const app = (
    <StoreProvider store={store} {..._props}>
      {children}
    </StoreProvider>
  );

  /* istanbul ignore else */
  if (process.env.NODE_ENV === 'test') {
    return app;
  }
  /* istanbul ignore next */
  ReactDOM.hydrate(app, rootNode);
}
